import { useContent } from "contexts/contentContext/contentContext";
import queryString from "query-string";
import React from "react";
import { Link, useLocation } from "react-router-dom";

import "./PurchaseRetry.scss";
import Button from "components/Elements/Button/Button";
import config from "config";

const PurchaseRetry = () => {
  // get params from url of code and id
  const location = useLocation();
  const { getTextByKey } = useContent();
  const searchParams = queryString.parse(location.search);
  const id = searchParams.param;
  const code = searchParams.code;

  let errorMessage = "";

  switch (code) {
    case "001":
      errorMessage = getTextByKey("purchase-retry-001");
      break;
    case "004":
      errorMessage = getTextByKey("purchase-retry-004");
      break;
    case "006":
      errorMessage = getTextByKey("purchase-retry-006");
      break;
    case "500":
      errorMessage = getTextByKey("purchase-retry-500");
      break;
    case "999":
      errorMessage = getTextByKey("purchase-retry-999");
      break;
  }

  return (
    <div className="container">
      <div className="title">{errorMessage}</div>
      <div className="retry-button">
        <Link to={config.billingurl + `/Pelecard/frame/${id}`}>
          <Button>{getTextByKey("purchase-retry-try-again")}</Button>
        </Link>
      </div>
    </div>
  );
};

export default PurchaseRetry;
